import { observable } from "mobx";
import Model from "~/models/Model";

class SubscriptionEvent extends Model {
  /**
   * @property {number|null}
   */
  @observable year = null;

  /**
   * @property {number|null}
   */
  @observable month = null;

  /**
   * @property {number|null}
   */
  @observable day = null;

  /**
   * @property {number|null}
   */
  @observable subscriptionId = null;

  /**
   * @property {string|null}
   */
  @observable type = null;

  /**
   * @property {number|null}
   */
  @observable billingCycle = null;

  /**
   * @property {number|null}
   */
  @observable totalAmount = null;

  /**
   * @property {number|null}
   */
  @observable totalAmountWithTaxes = null;
}

export default SubscriptionEvent;
